export default __webpack_public_path__ + "static/media/space_part1.48ce962d.png";